import type { TSubAccountData } from "../types";

export const useSubAccountStore = defineStore("sub-account-store", () => {
    const { $publicApi } = useNuxtApp();

    const inviteMember = async (payload: Ref<{ email: string }>) =>
        await useLazyAsyncData<{ msg: string }>(
            "invite-member",
            async () => await $publicApi<{ msg: string }>("/subaccount", { method: "POST", body: payload.value }),
            { immediate: false }
        );

    const subAccountData = ref<TSubAccountData>({} as TSubAccountData);

    return { inviteMember, subAccountData };
});
